import React, { Component } from "react";
import {
  relevantAutomations,
  roleBasedDataMappings,
} from "../../userOnboardingConstants";
export const userOnboardingContext = React.createContext();

class userOnboardingContextProvider extends Component {
  constructor(props) {
    super(props);
    this.state = {
      children: props.children,
      user: {
        name: "",
        email: "",
        role: "",
        objectives: [],
        challenges: [],
        objectivesExtraFields: 0,
        challengesExtraFields: 0,
        automationCardDetail:[],
        recommendedAutomations:[],
        relevantAutomations:relevantAutomations,
        roleBasedDataMappings:roleBasedDataMappings
      },
      setUser: this.setUser,
    };
  }

  setUser = (user) => {
    this.setState({ user });
  };

  render() {
    return (
      <userOnboardingContext.Provider value={this.state}>
        {this.state.children}
      </userOnboardingContext.Provider>
    );
  }
}

export default userOnboardingContextProvider;
